import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const marker = '/img/icons/destacado.svg';
const mintCircle = '/img/icons/mono-verde.svg';
const grayCircle = '/img/icons/mono-gray.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    color: '#10587f',
  },
  exp_panel : {
    boxShadow: 'none',
  },
  exp_summary: {
    padding: 0,
    justifyContent: 'flex-start',
    minHeight: 28,
    //borderBottom: '0.5px solid #e7e7e7',
    '&$expanded': {
        //borderBottom: 'none'
    }
  },
  expanded: {},
  exp_summary_content: {
    margin: 0,
    flexGrow: 0,
  },
  exp_details: {
    flexFlow: 'column',
  },
  exp_icon: {
    color: '#013957',
    marginLeft: 5,
    padding: 0
  },
}));

export default function Instructions() {
  const classes = useStyles();
  return (
    <>
      <ExpansionPanel classes={{root: classes.exp_panel}}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon style={{width:24,height:20}}/>}
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{root: classes.exp_summary, expanded: classes.expanded, content: classes.exp_summary_content, expandIcon: classes.exp_icon}}
        >
          <Typography className={classes.heading}>Instrucciones</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails classes={{root: classes.exp_details}}>
          <div className="messages-instructions-contacts">
            <p>Agrega a tus contactos</p>
            <div style={{ display: 'flex' }}>
              <img
                src={marker}
                alt="icono destacado"
                width="24px"
                height="24px"
                style={{ marginRight: 8 }}
              />
              <p>
                Marcando este icono, usted puede clasificar los mensajes
                de clientes potenciales, agregándolos como parte de su directorio,
                desde ahí podrá encontrar rápidamente los datos del cliente,
                así como desmarcarlos si ya no quiere ese mensaje.
              </p>
            </div>
          </div>
          <div className="messages-instructions-class">
            <p>Clasificación</p>
            <p>
              Puede identificar los mensajes provenientes de usuarios
              registrados y los que no, en nuestra plataforma
            </p>
            <div>
              <div className="user-green">
                <img
                  src={mintCircle}
                  className="user-green-circle"
                  alt="indicador menta"
                />
                <div className="user-green-text">
                  <p>
                    Los mensajes de color verde clasifican a los usuarios
                    registrados.{' '}
                  </p>
                </div>
              </div>
              <div className="user-gray">
                <img
                  src={grayCircle}
                  className="user-gray-circle"
                  alt="indicador gris"
                />
                <div className="user-gray-text">
                  <p>
                    Los mensajes marcados con color gris son personas que no
                    estan registradas en nuestra plataforma pero pueden tener
                    contacto contigo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
}
